<template>
  <div class="page__table_second">
    <div class="table-headers">
      <p v-for="label of header">{{ label }}</p>
    </div>
    <div class="table-body">
      <div v-for="branch of body" :key="branch.id">
        <div class="data">
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
          <p>{{ branch.branch_name }}</p>
        </div>
      </div>

<!--      <div style="text-align: center;" v-if="empty">-->
<!--        <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Array,
      required: true
    },
    body: {
      type: Array,
      required: true
    },
  },
  methods: {
    handleClick: function(val) {
      this.$emit('changePage', val)
    }
  }
}
</script>

<style scoped>
.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}
.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding: 0 1rem;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
</style>
